import { FormAlert } from "@NP-Webber/crm-kit";
import type { UiLoadState } from "./types";

type Props = {
  state: UiLoadState;
  errorMessage?: string;
  emptyMessage?: string;
  permissionMessage?: string;
};

export function UiStateMessage({
  state,
  errorMessage = "אירעה שגיאה בטעינת הנתונים.",
  emptyMessage = "אין נתונים להצגה.",
  permissionMessage = "אין הרשאה לצפות בתוכן זה.",
}: Props) {
  if (state === "loading") {
    return <p className="engine-state engine-state--loading">טוען…</p>;
  }
  if (state === "empty") {
    return <FormAlert severity="info">{emptyMessage}</FormAlert>;
  }
  if (state === "error") {
    return <FormAlert severity="error">{errorMessage}</FormAlert>;
  }
  if (state === "permission") {
    return <FormAlert severity="warning">{permissionMessage}</FormAlert>;
  }
  return null;
}
